import { DueStatus } from "@portal/BaseComponents/Table/Components/DueStatus/DueStatus";
import { Invoice } from "@portal/types/entities/invoice";
import { CellRenderProps } from "@sinecycle/growcomponents";

function DueDateCell(props: Partial<CellRenderProps<Invoice>>) {
  const { data } = props;
  if (!data) return;

  return (
    <>
      {props.invoiceStatusConfig.CLOSED.includes(props.data?.status) ? (
        "-"
      ) : (
        <DueStatus date={data.due_date} />
      )}
    </>
  );
}

export { DueDateCell };
